import * as React from "react";

import { PageLayout } from "@/shared/components";

import styles from "./Devices.module.css";
import { DevicesList } from "./DevicesList";

export const Devices: React.FC = () => {
  return (
    <PageLayout title={"Roboto - Devices"} headerContentLeft={"Devices"}>
      <div className={styles.content}>
        <div className={styles.table}>
          <DevicesList />
        </div>
      </div>
    </PageLayout>
  );
};
